export const toDataUri = (svg: string) => {
  return `url('data:image/svg+xml,${encodeURIComponent(svg)}')`;
};

export const extractViewBox = (svg: string) => {
  const regex = /viewBox="([-?\d ]+)"/;
  const res = regex.exec(svg);
  if (!res) return "0 0 16 16"; // default viewBox
  return res[1];
};

export const prefixId = (svg: string, idPrefix: string) => {
  return svg
    .replace(/id="([^"]+)"/g, `id="${idPrefix}_$1"`)
    .replace(/url\(#([^)]+)\)/g, `url(#${idPrefix}_$1)`)
    .replace(/xlink:href="#([^"]+)"/g, `xlink:href="#${idPrefix}_$1"`);
};

const isUniqColor = (result: RegExpMatchArray | null) => {
  if (!result) return false;
  return new Set(result).size < 2;
};

export const normalizeColor = (
  svg: string,
  fill: string,
  stroke: string,
  forced = false,
) => {
  let result = svg;

  if (fill !== "none") {
    const regex = /fill="([^"]+)"/g;
    if (forced || isUniqColor(svg?.match(regex)))
      result = result.replace(regex, `fill="${fill}"`);
  }

  if (stroke !== "none") {
    const regex = /stroke="([^"]+)"/g;
    if (forced || isUniqColor(svg?.match(regex)))
      result = result.replace(regex, `stroke="${stroke}"`);
  }

  return result;
};
